import request from "../util/request";
import {APP_KEY,API_URL,WEB_CODE} from "../util/constants";

//获取教师已经添加过的班级科任接口
export function getKerenListRequest(callback) {

    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", "teacher_keren_list");
    formData.append("phone",sessionStorage.getItem('teacherphone'));

    return fetch(API_URL+'/index.php/Apiadmin/u',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);
    });
}

//获取年级下班级接口参数
export function getClassByGradeRequest(grade,callback) {

    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", "getclass_bygrade");
    formData.append("grade",grade);

    return fetch(API_URL+'/index.php/Apiadmin/u',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);
    });
}

//获取学科接口参数
export function getAllXuekeListRequest(grade,callback) {

    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", "keren_list");

    return fetch(API_URL+'/index.php/Apiadmin/u',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);
    });
}

//教师添加科任接口
export function addKerenRequest(xueke,xueke_name,classcode,classname,grade,callback) {

    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", "teacher_keren_add_pc");
    formData.append("phone",sessionStorage.getItem('teacherphone'));
    formData.append("name", sessionStorage.getItem('name'));
    formData.append("xueke", xueke);
    formData.append("xueke_name", xueke_name);
    formData.append("classcode", classcode);
    formData.append("classname", classname);
    formData.append("grade", grade);

    return fetch(API_URL+'/index.php/Apiadmin/u',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);
    });
}

//删除单个科任信息
export function delKerenRequest(id,callback) {

    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", "teacher_keren_del");
    formData.append("id",id);


    return fetch(API_URL+'/index.php/Apiadmin/u',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);
    });
}


